import React, { useEffect, useState } from "react";
import { Router } from "react-router-dom";
import Script from "react-load-script";
import routes from "./routes";
import "./App.scss";
import { init } from "./libs/react-mpk/hocs";
import customInit from "./libs/custom/customInit"
import qs from 'query-string';

const App = ({envStore, navigationStore, sipStore}) => {
  const [ checked, setChecked ] = useState(false);

  useEffect(() => {
    if(!checked && window.location.pathname === '/'){
      const parsedUrl = qs.parseUrl(window.location.href);
      navigationStore.redirectTo(`/${envStore.env.applicationType}${Object.keys(parsedUrl.query).length > 0 ? `?${qs.stringify(parsedUrl.query)}` : ''}`)
      setChecked(true);
    }
  }, [checked])

  useEffect(() => {
    async function initData() {
      if(localStorage.getItem('sip-company-active')) {
        var d = JSON.parse(localStorage.getItem('sip-company-active'))
        sipStore.setCompany(d)
      }
      if(localStorage.getItem('sip-periode-active')) {
        var d = JSON.parse(localStorage.getItem('sip-periode-active'))
        sipStore.setPeriode(d)
      }
      if(localStorage.getItem('sip_setting')) {
        var d = JSON.parse(localStorage.getItem('sip_setting'))
        sipStore.setSetting(d)
      }
    }

    initData()
  }, [])

  return (
    <div className="App mpk-full viewport-height">
      {Object.keys(envStore.env.widgetInterface).map((key) => (
        <Script
          key={`widget-interface-${key}`}
          url={envStore.env.widgetInterface[key].url}
        />
      ))}
      <Router history={navigationStore.browserHistory}
        className="mpk-position relative"
      >
        {routes()}
      </Router>
      {/* {envStore.kbs && envStore.kbs.length > 0 ? (
        <SupportMpk appName={appInfo.name} kbs={kbs} />
      ) : null} */}
    </div>
  );
}

export default customInit()(App);
